export {
  isClerkAPIResponseError,
  isClerkRuntimeError,
  isEmailLinkError,
  isKnownError,
  isMetamaskError,
  isReverificationCancelledError,
  EmailLinkErrorCode,
  EmailLinkErrorCodeStatus,
} from '@clerk/shared/error';
